import React from "react";
import { withRouter } from "react-router-dom";
import classNames from "classnames";

let Modal = (props) => {
  const {
    history,
    name,
    header,
    children,
    footer,
    className,
    hideClose,
    ...otherProps
  } = props;
  return (
    <div className={classNames("modal", className)} {...otherProps}>
      <div className="overlay" onClick={() => history.goBack()} />
      <div className="dialog">
        {header && <div className="header">{header}</div>}
        <div className="body">{children}</div>
        {footer && <div className="footer">{footer}</div>}
      </div>
    </div>
  );
};

Modal = withRouter(Modal);

export { Modal };

// {!hideClose && (
//   <button
//     className="uk-modal-close-default"
//     type="button"
//     data-uk-close
//   />
// )}



// WEBPACK FOOTER //
// ./src/ui/elements/Modal.js